import React, { useState, useEffect } from "react";
import DataTable from "../../Common/DataTable/DataTable";
import { mcbAllTransactions, transactionReportDownload } from "../../api";
import CustomSpinner from "../../Common/Spinner";
import styles from "./transaction.module.css";
import { Offcanvas } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import { transactionColumns  } from "../../utils/tableHeader";
import Pagination from "../../Common/Pagination/Pagination";
import DataLoader from "../../Common/DataLoader/DataLoader";
import TransactionMainDetail from "./TransactionMainDetail";
import TransactionOtherDetail from "./TransactionOtherDetail";
import { Spinner } from "react-bootstrap";
import download from "../../public/images/download.svg";

const LienTransaction = ({ userId, partnerCode }) => {
  const [dataLoading, setDataLoading] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showCanvas, setShowCanvas] = useState(false);
  const [canvasData, setCanvasData] = useState(null);
  const [activeKey, setActiveKey] = useState(["0"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const fetchTransactionDetails = async (page = 1) => {
  try {
    setDataLoading(true);

    const response = await mcbAllTransactions(
      userId,
      "",
      "",
      "",
      "",
      page,
      pageSize,
      "GLOBAL_LIEN",
      partnerCode
    );

    if (response?.status === 200) {
      const transactionList = response?.data?.data?.transactions || [];
      const count = response?.data?.data?.count || 0;

      setTransactionData(transactionList);
      setTotalPages(Math.ceil(count / pageSize));
      setErrorMessage(null);
    } else {
      setErrorMessage(
        response?.data?.message || "Failed to fetch transaction details"
      );
    }
  } catch (error) {
    setErrorMessage(error?.response?.data?.message || "Something went wrong");
  } finally {
    setDataLoading(false);
  }
};

  const handleToggle = (key) => {
    setActiveKey((prev) =>
      prev.includes(key) ? prev.filter((tab) => tab !== key) : [...prev, key]
    );
  };

  const handleClickRow = async (data) => {
    setCanvasData(null);
    setShowCanvas(true);

    try {
      setCanvasData(data);
    } catch (error) {
      console.error("Error fetching transaction details:", error);
    }
  };

  // useEffect(() => {
  //   fetchTransactionDetails(currentPage);
  // }, [userId, currentPage]);

  
    useEffect(() => {
      fetchTransactionDetails(currentPage);
    }, [userId, currentPage]);
    const downloadReceipt = async (transactionNo) => {
      if (!transactionNo) return;
  
      setDownloadLoading(true);
      try {
        const resp = await transactionReportDownload({}, transactionNo);
  
        if (resp?.status === 200 && resp?.data) {
          const blob = new Blob([resp.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
  
          const link = document.createElement("a");
          link.href = url;
          link.download = `Transaction_Receipt_${transactionNo}.pdf`;
          link.click();
  
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error("Receipt Download Error:", error);
      } finally {
        setDownloadLoading(false);
      }
    };

  return (
    <DataLoader isLoading={dataLoading} error={errorMessage}>
      <div style={{ marginTop: "30px" }}>
        <DataTable
          columns={transactionColumns}
          list={transactionData}
          rowClick={true}
          handleClickRow={handleClickRow}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pagination={true}
        />
        <Offcanvas
          show={showCanvas}
          onHide={() => setShowCanvas(false)}
          placement="end"
          className={styles.offcanvas}
          backdropClassName={styles.backgroundBlur}
          style={{ color: "white" }}
        >
          <Offcanvas.Header
            closeButton
            style={{
              backgroundColor: "#343434",
              color: "white",
              fontSize: "15px",
              height: "50px",
            }}
          >
<Offcanvas.Title
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              Transaction Details
              <div className={styles.downloadContainer}>
                {canvasData?.transaction_transaction_no &&(
                canvasData?.transaction_type === "CONVERSION" || (
                canvasData?.transaction_type === "TRANSFER" &&
                canvasData?.to_account_account_no?.trim())) &&
                canvasData?.transaction_status !== "FAILED" &&
                canvasData?.transaction_status !== "REJECTED" && (
                    <span
                      className={styles.DownloadButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadReceipt(canvasData.transaction_transaction_no);
                      }}
                    >
                      {downloadLoading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className={styles.spinnerButton}
                        />
                      ) : (
                        <img
                          src={download}
                          alt="download"
                          className={styles.iconButton}
                        />
                      )}
                      Download Receipt
                    </span>
                  )}
              </div>
            </Offcanvas.Title>          </Offcanvas.Header>
          <Offcanvas.Body>
            {canvasData ? (
              <Accordion
                activeKey={activeKey}
                className={styles.accordionContainer}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header className={styles.accordionHeader}>
                    Main Details
                  </Accordion.Header>
                  <Accordion.Body className={styles.accordionBody}>
                    <TransactionMainDetail canvasData={canvasData} />
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1" style={{ marginTop: "20px" }}>
                  <Accordion.Header
                    onClick={() => handleToggle("1")}
                    className={styles.accordionHeader}
                  >
                    Other Details
                  </Accordion.Header>
                  <Accordion.Body className={styles.accordionBody}>
                    <TransactionOtherDetail canvasData={canvasData} />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            ) : (
              <div
                style={{
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CustomSpinner />
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </DataLoader>
  );
};

export default LienTransaction;
